import Image from 'components/elements/Image'

import styles from './avatarCircle.module.scss'

type Props = {
  src: string
  username?: string
  className?: string
}

const defaultAvatar = 'https://storage.googleapis.com/topdekt-user/avatars/default/avatar_colorless.svg'

const AvatarCircle = ({ src, username, className }: Props) => (
  <Image alt={`${username || ''} avatar`} src={src || defaultAvatar} className={`${styles.avatar} ${className}`} />
)

export default AvatarCircle
